import React, { useEffect, useState } from "react";
import "./Categories.css";
import Top_Filter_Div from "./top_filter_div/Top_Filter_Div";
import Category_Slider from "./category_slider/Category_Slider";
import { Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllSubCategory,
  getAllSubCategoryproduct,
  HighLowPrice,
} from "../../features/master/masterSlice";
import {
  getAllProducts,
  getAllMatress,
  getAllProductsShape,
} from "../../features/products/productsSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Common_Product_Card from "../common_components/common_product_card/Common_Product_Card";
import { variant_type } from "../../utils/common";

const Product_Listing_Page = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [subCategoryId, setSubCategoryId] = useState(null);
  const { id } = useParams();
  const dispatch = useDispatch();
  const allProducts = useSelector((state) => state.product.allProducts);
  const highlowprice = useSelector((state) => state.master.high_low_price);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const categoryName = searchParams.get("category_name");
  const [currentPage, setCurrentPage] = useState(1);
  const categoryImage = searchParams.get("category_image");
  const subId = searchParams.get("subcategory_id");
  const shapeId = searchParams.get("shape_id")
    ? Number(searchParams.get("shape_id"))
    : null;

  const [activeSize, setActiveSize] = useState([]);
  const [activeMattress, setActiveMattress] = useState([]);
  const [activeHeight, setActiveHeight] = useState([]);

  const [discount, setDiscount] = useState();
  useEffect(() => {
    dispatch(HighLowPrice());
  }, [dispatch]);
  const [priceRange, setPriceRange] = useState([0, 0]);

  useEffect(() => {
    if (highlowprice) {
      setPriceRange([
        Number(highlowprice?.lowest_price) || 0,
        Number(highlowprice?.highest_price) || 0,
      ]);
    }
  }, [highlowprice]);
  const navigate = useNavigate();

  // Initialize from query params
  useEffect(() => {
    if (subId) {
      setSubCategoryId(Number(subId));
    }
  }, [subId]);

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   if (subCategoryId !== null) {
  //     params.set("subcategory_id", subCategoryId);
  //     setSubCategoryId(Number(subCategoryId));
  //   } else {
  //     params.delete("subcategory_id");
  //   }
  //   navigate(`${location.pathname}?${params.toString()}`, { replace: true });

  //   if (!id) return;

  //   dispatch(
  //     getAllProducts({
  //       category_id: Number(id),
  //       subcategory_id: subCategoryId || "",
  //       height_id: activeHeight || "",
  //       size_id: activeSize || "",
  //       mattress_id: activeMattress || "",
  //       priceOrder: priceRange || "",
  //       sortBy: selectedOption || "",
  //       page: currentPage || 1,
  //       discount: discount || "",
  //       shape_id: shapeId || "",
  //       per_page: 10,
  //     }),
  //   );
  // }, [
  //   id,
  //   subCategoryId,
  //   activeHeight,
  //   activeSize,
  //   activeMattress,
  //   priceRange,
  //   selectedOption,
  //   currentPage,
  //   discount,
  //   shapeId,
  //   dispatch,
  // ]);

  // useEffect(() => {
  //   dispatch(
  //     getAllProducts({
  //       category_id: id,
  //       subcategory_id: subCategoryId,
  //       soft_type_id: softTypeId || "",
  //       metal_id: activeSize || "",
  //       size_id: sizeId || "",
  //       discount_min: discountMin || "",
  //       discount_max: discountMax || "",
  //       priceOrder: selectedOption || "",
  //       sortBy: selectedOption || "",
  //       page: currentPage || 1,
  //       per_page: 10,
  //     }),
  //   );
  // }, [
  //   softTypeId,
  //   activeSize,
  //   sizeId,
  //   discountMin,
  //   discountMax,
  //   selectedOption,
  //   currentPage,
  //   dispatch,
  // ]);

  // const totalPages = Math.ceil(allProducts?.total_pages);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (subCategoryId !== null) {
      params.set("subcategory_id", subCategoryId);
    } else {
      params.delete("subcategory_id");
    }

    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  }, [subCategoryId]);

  useEffect(() => {
    if (!id) return;

    dispatch(
      getAllProducts({
        category_id: Number(id),
        subcategory_id: subCategoryId || "",
        height_id: activeHeight?.length > 0 ? JSON.stringify(activeHeight) : "",

        size_id: activeSize?.length > 0 ? JSON.stringify(activeSize) : "",

        mattress_id:
          activeMattress?.length > 0 ? JSON.stringify(activeMattress) : "",
        priceOrder: Array.isArray(priceRange) ? priceRange.join(",") : "",
        sortBy: selectedOption || "ASC",
        page: currentPage || 1,
        discount: discount || "",
        shape_id: shapeId || "",
        per_page: 10,
      }),
    );
  }, [
    id,
    subCategoryId,
    activeHeight,
    activeSize,
    activeMattress,
    priceRange,
    selectedOption,
    currentPage,
    discount,
    shapeId,
    dispatch,
  ]);

  const totalPages = Math.max(allProducts?.total_pages || 0);

  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  const subcategories = useSelector((state) => state.master.all_subcategories);

  useEffect(() => {
    if (id) {
      dispatch(getAllSubCategoryproduct({ category_id: id }));
    }
  }, [dispatch, id]);

  return (
    <section className="Product_Listing_Page">
      <Tab.Container id="left-tabs-example" defaultActiveKey="Grid">
        <Top_Filter_Div
          setDiscount={setDiscount}
          discount={discount}
          priceRange={priceRange}
          setPriceRange={setPriceRange}
          pageTitle={categoryName}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          setActiveMattress={setActiveMattress}
          activeMattress={activeMattress}
          activeSize={activeSize}
          setActiveSize={setActiveSize}
          setActiveHeight={setActiveHeight}
          activeHeight={activeHeight}
        />

        <div className="container">
          <Category_Slider
            categoryImage={categoryImage}
            categoryName={categoryName}
            categoryId={id}
            categories={subcategories}
            subCategoryId={subCategoryId}
            setSubCategoryId={setSubCategoryId}
          />

          <Tab.Content>
            <Tab.Pane eventKey="Grid">
              <div className="row">
                {allProducts?.data?.length > 0 ? (
                  allProducts?.data?.map((product) => {
                    let metal;
                    let size;
                    let triple;
                    if (
                      Number(product?.variant_type_id) ===
                      Number(variant_type.Single)
                    ) {
                      metal = product?.Product_Variants?.[0];
                    } else if (
                      Number(product?.variant_type_id) ===
                      Number(variant_type.Double)
                    ) {
                      metal = product?.Product_Variants?.[0];
                      size = metal?.Double_Variants?.[0];
                    } else if (
                      Number(product?.variant_type_id) ===
                      Number(variant_type.Triple)
                    ) {
                      metal = product?.Product_Variants?.[0];
                      size = metal?.Double_Variants?.[0];
                      triple = size?.Triple_Variants?.[0];
                    }

                    const activeVariant = triple || size || metal;

                    return (
                      <div
                        key={product.id}
                        className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-5 custom_col"
                      >
                        <Common_Product_Card
                          product={product}
                          id={product.id}
                          imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                          vdoSrc={process.env.REACT_APP_IMG_URL + product.video}
                          productName={product.name}
                          sellingPrice={activeVariant?.price || 0}
                          mrp={activeVariant?.mrp || 0}
                          kgText={metal?.Metal?.name}
                          discount={
                            activeVariant?.mrp
                              ? (
                                  ((parseFloat(activeVariant?.mrp || 0) -
                                    parseFloat(activeVariant?.price || 0)) /
                                    parseFloat(activeVariant?.mrp || 1)) *
                                  100
                                ).toFixed(0)
                              : 0
                          }
                          btnText={"View Details"}
                          feature={product?.Product_Fetures}
                        />
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      fontWeight: "bold",
                      width: "100%",
                      color: "black",
                    }}
                  >
                    Product Not Available
                  </div>
                )}
              </div>
              <div className="pagination mt-4 d-flex justify-content-center align-items-center gap-2">
                <button
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lsaquo;
                </button>

                {/* Always show first two pages */}
                {[currentPage].map((page) => (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={page === currentPage ? "active" : ""}
                  >
                    {page}
                  </button>
                ))}
                {/* Show ... if there are more than 3 pages */}
                {totalPages > 3 && (
                  <>
                    <span>...</span>

                    {/* Show last page */}
                    <button
                      onClick={() => handlePageChange(totalPages)}
                      className={currentPage === totalPages ? "active" : ""}
                    >
                      {totalPages}
                    </button>
                  </>
                )}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &rsaquo;
                </button>
                <button
                  onClick={() => handlePageChange(totalPages)}
                  disabled={currentPage === totalPages}
                >
                  &raquo;
                </button>
              </div>
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </section>
  );
};
export default Product_Listing_Page;
